// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"18":"CustomerStories","34":"companyBusiness","180":"companyWorth","333":"industryTrends","522":"aboutUs","594":"about","799":"JoinUs"}[chunkId] + "." + {"18":"96a139d9","34":"a3dc9e86","180":"50acae43","333":"4d989a7c","522":"f7fc75ef","594":"4db9ca6d","799":"589d8d4f"}[chunkId] + ".css";
};